import React from "react";
import { Input as AndInput, Col } from "antd";
import "./style.scss";

interface InputProps {
  placeholder?: string;
  value?: string;
  onChange?: any;
  ref?: any;
  onKeyDown?: any;
  style?: React.CSSProperties;
  type?: any;
  disabled?: boolean;
  className?: any;
  defaultValue?: string;
}

const inputStyle = {
  width: '85%',
  minHeight: '37px',
  paddingLeft: '12px',
  paddingRight: '12px',
  fontSize: '14px',
  lineHeight: '22px',
  fontWeight: 400,
  background: '#F3F4F6FF',
  borderRadius: '6px',
  borderWidth: '0px',
  outline: 'none'
};

const TextInput = (props: InputProps) => {
  const { placeholder, value, onChange, ref, type, onKeyDown, disabled, className, defaultValue, style } = props;
  return (
    <Col className="input-container">
      <AndInput
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        ref={ref}
        onKeyDown={onKeyDown}
        style={{ ...inputStyle, ...(style || {}) }}
        disabled={disabled}
        type={type}
        className={className}
      />
    </Col>
  );
};

const Input = Object.assign(TextInput, {});

export default Input;
